export const APP_LANGUAGES = [
    { code: 'de', label: 'DE', backendNumber: '0' },
    { code: 'en', label: 'EN', backendNumber: '1' },
    { code: 'cs', label: 'CZ', backendNumber: '2' },
];
